export const NETWORKS = {
    EURO: 'EURO_Network',
    GROSZEK: 'GROSZEK_Network',
    ABC: 'ABC_Network'
}

export const NETWORKS_CODES = {
    EURO: 'EURO_SKLEP',
    GROSZEK: 'GROSZEK',
    ABC: 'ABC'
}
